import { computed, makeObservable, observable, action } from 'mobx';

import { FieldModel } from 'shared/models/form';
import { IUiStore } from 'shared/entities/store/uiStore';
import {
  MenuSectionItem,
  MenuSectionItemChild
} from 'shared/newEntities/components/MenuSection';
import { ComponentType } from 'shared/entities/components/Component';
import { IRouterStore } from 'shared/entities/store/routerStore';
import { IPermissionsStore } from 'shared/entities/store/permissionsStore';

import { getSections } from './sections';

export class PageTemplateMenuStore {
  readonly uiStore: IUiStore;
  readonly routerStore: IRouterStore;
  readonly permissionsStore: IPermissionsStore;
  readonly activeSectionChild: FieldModel<MenuSectionItemChild | null> =
    new FieldModel(null);
  private _sections: MenuSectionItem[] = [];

  constructor({
    uiStore,
    routerStore,
    permissionsStore
  }: {
    uiStore: IUiStore;
    routerStore: IRouterStore;
    permissionsStore: IPermissionsStore;
  }) {
    this.uiStore = uiStore;
    this.routerStore = routerStore;
    this.permissionsStore = permissionsStore;

    makeObservable<PageTemplateMenuStore, '_sections'>(this, {
      _sections: observable.ref,
      sections: computed,
      setSections: action
    });
  }

  get sections(): MenuSectionItem[] {
    return this._sections.filter(
      (section) =>
        section.action.type !== ComponentType.link ||
        this.permissionsStore.isAllowedProjectRoute(section.action.mask)
    );
  }

  get isMobileMenu(): boolean {
    return this.uiStore.isMobileSize;
  }

  get isMenuOpened(): boolean {
    return this.uiStore.menuState.opened;
  }

  get activeSection(): MenuSectionItem | null {
    return (
      this.sections?.find((section) => {
        const isActive =
          (section.action.type === ComponentType.link &&
            !!this.routerStore.matchPath(section.action.mask)) ||
          (section.action.type === ComponentType.div &&
            section.action.isActive);
        return isActive;
      }) ?? null
    );
  }

  toggleMenu = () => {
    this.uiStore.toggleMenu();
  };

  setSections = (projectId: string | null) => {
    this._sections = getSections(projectId);
  };
}
